import React, { useState, useEffect } from 'react';
import './Instagram.css';

const WORDS = ['Evidence.', 'Discovery.', 'Strategy.', 'Intelligence.'];

function ARMark({ size = 120 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none"
      style={{ filter: 'drop-shadow(0 0 20px rgba(0,212,255,0.5))' }}>
      <polygon points="24,2 44,13 44,35 24,46 4,35 4,13" fill="none" stroke="#00d4ff" strokeWidth="1.5"/>
      <polygon points="24,7 39,15.5 39,32.5 24,41 9,32.5 9,15.5" fill="rgba(0,212,255,0.06)" stroke="rgba(0,212,255,0.3)" strokeWidth="0.75"/>
      <text x="24" y="30" textAnchor="middle" fontFamily="Bebas Neue, sans-serif" fontSize="18" fill="#00d4ff" letterSpacing="1">AR</text>
    </svg>
  );
}

function Slide1() {
  const [tick, setTick] = useState(0);
  useEffect(() => {
    const t = setInterval(() => setTick(n => n + 1), 2200);
    return () => clearInterval(t);
  }, []);

  return (
    <div className="ig-slide ig-slide-1">
      <div className="ig-scanline" />
      <div className="ig-badge">
        <span className="ig-badge-dot" />
        <span>ARIA Platform — Now Operational</span>
      </div>
      <div className="ig-mark"><ARMark size={100} /></div>
      <h1 className="ig-title">so, I did<br/><em>a thing</em></h1>
      <div className="ig-rotating">
        <span className="ig-rot-prefix">// Powered for </span>
        <span className="ig-rot-word" key={tick}>{WORDS[tick % WORDS.length]}</span>
      </div>
      <div className="ig-swipe">swipe for the receipts</div>
    </div>
  );
}

function Slide2() {
  const [visible, setVisible] = useState(0);
  useEffect(() => {
    const t = setInterval(() => setVisible(n => Math.min(n + 1, 10)), 400);
    return () => clearInterval(t);
  }, []);

  const lines = [
    { type: 'cmd', text: '$ aria --status' },
    { type: 'out', text: 'Loading intelligence modules...' },
    { type: 'ok', text: '✓ Evidence Database', val: '58,664 messages indexed' },
    { type: 'ok', text: '✓ Court Intel', val: '129,453 cases analyzed' },
    { type: 'ok', text: '✓ Financial Forensics', val: '$5.7B AUM mapped' },
    { type: 'ok', text: '✓ Legal Framework', val: '21 books synthesized' },
    { type: 'ok', text: '✓ Filing Engine', val: '6 motions deployed today' },
    { type: 'blank', text: '' },
    { type: 'cmd', text: '$ aria --deploy' },
    { type: 'final', text: 'All systems operational.' },
  ];

  const stats = [
    { v: '129K+', l: 'Court Cases Analyzed' },
    { v: '58.6K', l: 'Text Messages Parsed' },
    { v: '227K', l: 'Comms Forensically Analyzed' },
    { v: '17', l: 'SEC Exhibits Filed' },
    { v: '21', l: 'Legal Books Trained On' },
    { v: '3.4M+', l: 'Docket Entries Indexed' },
  ];

  return (
    <div className="ig-slide ig-slide-2">
      <div className="ig-terminal">
        <div className="ig-term-bar">
          <div className="ig-dot r" /><div className="ig-dot y" /><div className="ig-dot g" />
          <span className="ig-term-title">aria — session active</span>
        </div>
        <div className="ig-term-body">
          {lines.map((ln, i) => (
            <div className={`ig-tl ${i <= visible ? 'show' : ''}`} key={i}>
              {ln.type === 'cmd' && <><span className="ig-tc">{ln.text.slice(0,2)}</span><span className="ig-tw">{ln.text.slice(2)}</span></>}
              {ln.type === 'out' && <span className="ig-to">{ln.text}</span>}
              {ln.type === 'ok' && <><span className="ig-ts">{ln.text}</span>{' '}<span className="ig-tg">{ln.val}</span></>}
              {ln.type === 'blank' && <span>&nbsp;</span>}
              {ln.type === 'final' && <><span className="ig-ts">{ln.text}</span><span className="ig-cursor">█</span></>}
            </div>
          ))}
        </div>
      </div>
      <div className="ig-stats-grid">
        {stats.map((s, i) => (
          <div className="ig-stat" key={i}>
            <div className="ig-stat-v">{s.v}</div>
            <div className="ig-stat-l">{s.l}</div>
          </div>
        ))}
        <div className="ig-stat ig-stat-full">
          <div className="ig-stat-v">0</div>
          <div className="ig-stat-l">Lawyers on My Team</div>
        </div>
      </div>
    </div>
  );
}

function Slide3() {
  return (
    <div className="ig-slide ig-slide-3">
      <div className="ig-mark"><ARMark size={90} /></div>
      <div className="ig-quote">
        they took my kids, my home,<br/>
        and my voice.<br/><br/>
        so I built <strong>ARIA</strong> —<br/>
        and taught myself <span className="ig-gold">the law.</span>
      </div>
      <div className="ig-counter">103 DAYS WITHOUT MY CHILDREN</div>
      <div className="ig-url">arprose.com</div>
      <div className="ig-tagline">A.R. Pro Se — Strategic Operations</div>
    </div>
  );
}

export default function Instagram() {
  const [slide, setSlide] = useState(0);
  const slides = [<Slide1 />, <Slide2 />, <Slide3 />];

  return (
    <div className="ig-container" onClick={() => setSlide((slide + 1) % 3)}>
      <div className="ig-progress">
        {[0,1,2].map(i => (
          <div key={i} className={`ig-bar ${i <= slide ? 'active' : ''}`} />
        ))}
      </div>
      {slides[slide]}
      <div className="ig-tap-hint">tap to advance</div>
    </div>
  );
}
